export enum SeatPassangerEstatus {
  NO_ASSIGNED = 0,
  ASSIGNED = 1, 
  PAID = 2,
  PENDING_PAYMENT = 3,
  BENEFIT = 4
}
